export enum AppEnvMode {
  DEVELOPMENT = 'development',
  TEST = 'test',
  STAGING = 'staging',
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
}

export type TAppEnvMode = `${AppEnvMode}`;

// Vite injects `import.meta.env.MODE` at build time in consuming apps. The utils
// package isn't itself a Vite project and doesn't pull in vite/client types, so we
// read MODE through an unknown cast to avoid colliding with each app's own
// `ImportMetaEnv` augmentation.
const getViteMode = () => (import.meta as unknown as { env?: { MODE?: string } }).env?.MODE;

export const isProductionEnvironment = () => getViteMode() === AppEnvMode.PRODUCTION;

export const isNonProductionEnvironment = () => !isProductionEnvironment();
